import React from 'react';
import { Box, Typography, Stack } from '@mui/material';
import OperationsSelect from '../../components/OperationsSelect';

interface ViewControlsProps {
  statusFilter: string;
  sortBy: string;
  onStatusFilterChange: (value: string) => void;
  onSortByChange: (value: string) => void;
  resultsCount: number;
}

const ViewControls: React.FC<ViewControlsProps> = ({
  statusFilter,
  sortBy,
  onStatusFilterChange,
  onSortByChange,
  resultsCount
}) => {
  const statusOptions = [
    { value: 'All', label: 'All' },
    { value: 'Planning', label: 'Planning' },
    { value: 'Active', label: 'Active' },
    { value: 'Closed', label: 'Closed' },
    { value: 'Archived', label: 'Archived' }
  ];

  const sortOptions = [
    { value: 'Date', label: 'Date' },
    { value: 'Title', label: 'Title' }
  ];

  return (
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      spacing={2}
      sx={{
        alignItems: 'flex-end',
        mt: 3,
        mb: 2
      }}>
      <Box sx={{ minWidth: (theme) => theme.spacing(37.5) }}>
        <OperationsSelect
          value={statusFilter}
          onChange={onStatusFilterChange}
          options={statusOptions}
          label='Status'
        />
      </Box>
      <Box
        sx={{
          ml: 2,
          display: 'flex',
          alignItems: 'flex-end',
          height: (theme) => theme.spacing(7),
          paddingBottom: (theme) => theme.spacing(1)
        }}>
        <Typography>
          {resultsCount} {resultsCount === 1 ? 'Result' : 'Results'}
        </Typography>
      </Box>
      <Box sx={{ flex: 1 }} />
      <Box sx={{ minWidth: 300 }}>
        <OperationsSelect
          value={sortBy}
          onChange={onSortByChange}
          options={sortOptions}
          label='Sort'
        />
      </Box>
    </Stack>
  );
};

export default ViewControls;
